import { ComponentProps, useCallback } from 'react';
import { useIntl } from 'react-intl';
import CardLocation from '@alltrails/amplitude/enums/CardLocation';
import TrailDetailsActionLocation from '@alltrails/amplitude/enums/TrailDetailsActionLocation';
import logTrailDetailsActionTapped from '@alltrails/amplitude/events/logTrailDetailsActionTapped';
import logTrailDetailsAddToListButtonTapped from '@alltrails/amplitude/events/logTrailDetailsAddToListButtonTapped';
import { PageStrings } from '@alltrails/core/constants/pageStringHelpers';
import IconButton from '@alltrails/denali/components/IconButton';
import Heart from '@alltrails/denali/icons/Heart';
import HeartFilled from '@alltrails/denali/icons/HeartFilled';
import type { Size } from '@alltrails/denali/types';
import useReduxListItems from '@alltrails/lists/hooks/useReduxListItems';

const reduxListsAnalyticsInfo = { detailedCardLocation: 'trail banner' as CardLocation, page: PageStrings.TRAIL_PAGE, trailPageType: 'trail detail page' as const };

type SaveCtaProps = {
  buttonLocation?: TrailDetailsActionLocation;
  size?: Size<'sm' | 'md'>;
  trailId: number;
  testId?: string;
  variant?: ComponentProps<typeof IconButton>['variant'];
};

const SaveCta = ({ buttonLocation, trailId, variant, testId, size = 'md' }: SaveCtaProps) => {
  const intl = useIntl();

  const { isFavorite, handleFavoriteClick, listModal, signUpModal } = useReduxListItems(
    undefined,
    false /* preventAutoInitialize */,
    reduxListsAnalyticsInfo
  );

  const isTrailFavorite = isFavorite('trail', trailId);

  const onFavoriteClick = useCallback(() => {
    logTrailDetailsActionTapped({ trail_id: trailId.toString(), trail_page_action: 'save', trail_page_location: buttonLocation, trail_page_type: 'trail detail page' });
    logTrailDetailsAddToListButtonTapped({ trail_id: trailId });

    handleFavoriteClick('trail', trailId);
  }, [buttonLocation, handleFavoriteClick, trailId]);

  return (
    <>
      <IconButton
        icon={{ Component: isTrailFavorite ? HeartFilled : Heart }}
        onClick={onFavoriteClick}
        size={size}
        testId={testId}
        title={intl.formatMessage({ defaultMessage: 'Save' })}
        variant={variant}
      />
      {listModal}
      {signUpModal}
    </>
  );
};

export default SaveCta;
